import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MojoAvatarModule } from 'mojo-avatar';
import { MojoMarkSearchPhraseModule } from 'mojo-mark-search-phrase';


import { CompanyCardComponent } from './company-card.component';

@NgModule({
  imports: [CommonModule, MojoAvatarModule, MojoMarkSearchPhraseModule],
  declarations: [CompanyCardComponent],
  exports: [CompanyCardComponent]
})
export class CompanyCardModule { }
